/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Group_CreatedInputs */



/**
* | output |
* | --- |
* | "New group created" |
*
* @param {Team_Manager_Group_CreatedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_group_created = /** @type {((inputs?: Team_Manager_Group_CreatedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Group_CreatedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nouveau groupe créé")
	if (locale === "de") return /** @type {LocalizedString} */ ("Neue Gruppe erstellt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nuovo gruppo creato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Создана новая группа")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nuevo grupo creado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("创建新群组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新しいグループが作成されました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नया समूह बनाया गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Novo grupo criado")
	return /** @type {LocalizedString} */ ("New group created")
});